import React from 'react';

const AIDalamSeni: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        <b>Galeri Nasional Indonesia</b> mengejutkan dunia seni pada 2024 dengan memamerkan karya lukis berbasis AI berjudul <i>&quot;Rembrandt dari Nusantara&quot;</i> yang terjual seharga <b>Rp1,2 miliar</b>. Perdebatan pun muncul: <b>Bisakah mesin disebut seniman?</b>
      </p>

      <h2 className="text-2xl font-bold mb-4">Revolusi Kreatif yang Kontroversial</h2>
      <div className="bg-pink-50 border-l-4 border-pink-300 p-4 mb-6">
        <p>
          <b>&quot;AI tidak menggantikan seniman, tapi memperluas kemungkinan kreativitas&quot;</b> - <i>Dr. Maria Sutanto</i>, Kurator Seni Digital Galeri Nasional.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <div>
          <h3 className="text-xl font-semibold mb-3">🎨 Dunia Lukis AI</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li><b>MidJourney 6.0</b> bisa menghasilkan gambar dalam gaya Affandi</li>
            <li><b>DALL-E 4</b> membuat ilustrasi wayang kontemporer</li>
            <li>Teknologi <b>Style Transfer</b> mengubah foto biasa menjadi bergaya batik</li>
          </ul>
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-3">✍️ Sastra Digital</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>AI menulis puisi dengan gaya Chairil Anwar (<i>&quot;Aku Binatang Algorithm&quot;</i>)</li>
            <li>Generasi otomatis cerpen berlatar budaya Bali</li>
            <li>Lirik lagu pop dengan sentuhan lokal</li>
          </ul>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Proses Kreatif Unik AI</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Data Latih Budaya</strong> - Sistem mempelajari ribuan karya seni Nusantara</p>
        </li>
        <li>
          <p><strong>Kolaborasi Manusia-Mesin</strong> - Seniman memberikan prompt spesifik</p>
        </li>
        <li>
          <p><strong>Generasi dan Seleksi</strong> - AI menghasilkan varian, manusia memilih</p>
        </li>
        <li>
          <p><strong>Sentuhan Akhir</strong> - Penyempurnaan manual oleh seniman</p>
        </li>
      </ol>

      <div className="bg-yellow-50 p-4 rounded-lg mb-6">
        <h3 className="text-xl font-semibold mb-2">💼 Dampak Ekonomi</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Pasar <b>seni digital Indonesia</b> tumbuh 320% sejak 2023</li>
          <li>Munculnya profesi baru: <b>AI Art Director</b> dengan gaji Rp15-30 juta/bulan</li>
          <li>Komunitas <b>Seniman Hybrid</b> bermunculan di Yogyakarta dan Bandung</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold mb-4">Debat Etis</h2>
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Pendukung</th>
              <th className="border p-2">Penentang</th>
            </tr>
          </thead>
          <tbody>
            {[
              [
                "Demokratisasi seni - siapa pun bisa berkarya",
                "Mendevaluasi karya seniman tradisional"
              ],
              [
                "Pelestarian budaya melalui digitalisasi",
                "Pelecehan terhadap kearifan lokal"
              ],
              [
                "Inovasi gaya baru yang tak terbayangkan",
                "Karya menjadi terlalu homogen"
              ]
            ].map(([pro, kontra], idx) => (
              <tr key={idx}>
                <td className="border p-2">{pro}</td>
                <td className="border p-2">{kontra}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 className="text-2xl font-bold mb-4">Kasus Menarik: Wayang AI</h2>
      <p className="mb-4">
        Komunitas <b>Wayang Digital</b> di Solo menciptakan terobosan:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Generasi otomatis <b>tokoh wayang futuristik</b> dengan karakteristik Jawa</li>
        <li>Cerita <i>Mahabharata</i> versi AI dengan plot alternatif</li>
        <li>Pertunjukan <b>wayang kulit</b> dimana dalang berkolaborasi dengan AI</li>
      </ul>

      <div className="bg-green-50 border-l-4 border-green-400 p-4">
        <h3 className="text-xl font-semibold mb-2">🔮 Masa Depan Seni AI di Indonesia</h3>
        <p>
          <b>Pameran Seni AI Nusantara 2026</b> akan menjadi ajang pertama yang sepenuhnya menampilkan karya kolaborasi manusia-AI dengan tema budaya lokal. Kuratornya menjanjikan <i>&quot;Kejutan yang memadukan teknologi mutakhir dengan jiwa tradisi&quot;.</i>
        </p>
      </div>

      <p className="mt-6">
        Sementara perdebatan terus berlanjut, satu hal pasti: <b>AI telah membuka babak baru dalam ekspresi seni</b> - bukan sebagai pengganti, tapi sebagai kuas dan pena digital generasi baru.
      </p>
    </div>
  );
};

export default AIDalamSeni;